import { ThunkDispatch } from "core-integration/src/store";
import { getElementTypesBySquadPosition } from "core-integration/src/store/element-types/reducers";
import { updateElementTypeControl } from "core-integration/src/store/elements/thunks";
import {
  getProposedElements,
  getSavedPicks,
} from "core-integration/src/store/squad/reducers";
import {
  removeElement,
  restoreElement,
} from "core-integration/src/store/squad/thunks";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import PitchPlaceholder from "./PitchPlaceholder";
import SquadPitchElement from "./SquadPitchElement";

interface IOwnProps {
  pos: number;
  elementValue: React.ReactNode;
  renderElementMenu: (pos: number) => void;
  showSidebar: () => void;
}

const SquadPitchUnit = ({
  elementValue,
  pos,
  renderElementMenu,
  showSidebar,
}: IOwnProps) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const elementTypesByPosition = useSelector(getElementTypesBySquadPosition);
  const proposedElements = useSelector(getProposedElements);
  const savedPicks = useSelector(getSavedPicks);

  if (!elementTypesByPosition) {
    return null;
  }

  const showElementType = (elementTypeId: number) => {
    dispatch(updateElementTypeControl(elementTypeId));
    showSidebar();
  };

  const removeAndFilter = (pos: number) => {
    dispatch(removeElement(pos));
    dispatch(updateElementTypeControl(elementTypesByPosition[pos].thisType.id));
    showSidebar();
  };

  const hasSavedPicks = Object.keys(savedPicks).length > 0;
  const isPickedTransferElement =
    proposedElements[pos] &&
    hasSavedPicks &&
    (!savedPicks[pos] || savedPicks[pos].element !== proposedElements[pos].id);

  return (
    <>
      {proposedElements[pos] ? (
        <SquadPitchElement
          actionMe={() => {
            removeAndFilter(pos);
          }}
          elementId={proposedElements[pos].id}
          elementValue={elementValue}
          renderElementMenu={() => renderElementMenu(pos)}
          variant={isPickedTransferElement ? "target" : ""}
        />
      ) : savedPicks[pos] ? (
        <SquadPitchElement
          actionMe={() => {
            dispatch(restoreElement(pos));
          }}
          elementId={savedPicks[pos].element}
          elementValue={elementValue}
          renderElementMenu={() => renderElementMenu(pos)}
          isRemoved={true}
        />
      ) : (
        <PitchPlaceholder
          elementType={elementTypesByPosition[pos].thisType}
          onClick={() =>
            showElementType(elementTypesByPosition[pos].thisType.id)
          }
        />
      )}
    </>
  );
};

export default SquadPitchUnit;
